export * from './backend-unavailable';
export * from './feature-flags';
export * from './severity-colors';
export * from './value-type';

export const API = {
  FIRST_PAGE: 1,
  PAGE_SIZE: 10,
  ERROR_STATUS: {
    CONFLICT: 409,
    NOT_FOUND: 404,
  },
  PREFIX: '/api',
};

export const CANCEL_TOKEN_MSG = 'FRONTEND CANCEL REQUEST';

export const APP = {
  DEFAULT_LANGUAGE: 'ru',
};

export const LANGUAGE = {
  RU: 'ru',
  EN: 'en',
};

export const STORAGE = {
  SESSION: 'smp-session',
  LANGUAGE: 'language',
};

export const UI_STATE = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  FULFILLED: 'FULFILLED',
};

export const FORMAT = {
  DATE: 'DD.MM.YYYY HH:mm:ss',
  DATE_WITHOUT_SECONDS: 'DD.MM.YYYY HH:mm',
  TIME: 'HH:mm',
};

export const VALUE_TYPE = {
  STRING: 'STRING',
  INT: 'INT',
  FLOAT: 'FLOAT',
  BOOL: 'BOOL',
  STRING_LIST: 'STRING_LIST',
  DATETIME: 'DATETIME',
  JSONB: 'JSONB',
  TEXT: 'TEXT',
  FILE: 'FILE',
  INET: 'INET',
};

// NOTE: версия конструктора условий для построения запросов
export const SCHEME_VERSION = 'filters@1.0.0';

export const SRM = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
  HAS: 'has',
};